var _path, _g, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.4453 186.109C108.252 186.109 119.445 174.916 119.445 161.109C119.445 147.302 108.252 136.109 94.4453 136.109C80.6382 136.109 69.4453 147.302 69.4453 161.109C69.4453 174.916 80.6382 186.109 94.4453 186.109Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.664 191.666C130.471 191.666 141.664 180.473 141.664 166.666C141.664 152.859 130.471 141.666 116.664 141.666C102.857 141.666 91.6641 152.859 91.6641 166.666C91.6641 180.473 102.857 191.666 116.664 191.666Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.109 199.998C149.916 199.998 161.109 188.805 161.109 174.998C161.109 161.191 149.916 149.998 136.109 149.998C122.302 149.998 111.109 161.191 111.109 174.998C111.109 188.805 122.302 199.998 136.109 199.998Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.227 183.332C186.034 183.332 197.227 172.139 197.227 158.332C197.227 144.525 186.034 133.332 172.227 133.332C158.419 133.332 147.227 144.525 147.227 158.332C147.227 172.139 158.419 183.332 172.227 183.332Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.059 172.222C201.497 172.222 208.337 165.381 208.337 156.944C208.337 148.506 201.497 141.666 193.059 141.666C184.621 141.666 177.781 148.506 177.781 156.944C177.781 165.381 184.621 172.222 193.059 172.222Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.614 174.999C182.051 174.999 188.891 168.159 188.891 159.721C188.891 151.283 182.051 144.443 173.614 144.443C165.176 144.443 158.336 151.283 158.336 159.721C158.336 168.159 165.176 174.999 173.614 174.999Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4436 174.998C102.114 174.998 108.332 168.78 108.332 161.11C108.332 153.439 102.114 147.221 94.4436 147.221C86.773 147.221 80.5547 153.439 80.5547 161.11C80.5547 168.78 86.773 174.998 94.4436 174.998Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9476 158.332C58.8901 163.724 58.3359 169.297 58.3359 174.999C58.3359 194.886 65.0777 213.199 76.4006 227.776H212.493C223.816 213.199 230.558 194.886 230.558 174.999C230.558 169.297 230.004 163.724 228.946 158.332H59.9476Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2266 169.443H111.115",
    stroke: "#9CA3AF",
    strokeWidth: 6,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6719 230.554H222.252M213.894 61.1094L105.561 97.2205M219.45 105.554H94.4496",
    stroke: "#C4C4C4",
    strokeOpacity: 0.74,
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M116.668 86.1094V122.327M94.4453 105.554V124.998M102.779 97.2205V116.665",
    stroke: "#C4C4C4",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.0aa8544f9afcc0cba819d80b042fc16e.svg";
export { ForwardRef as ReactComponent };